/**
 * LuxuryImage port (LuxuryImage.tsx):
 * - IntersectionObserver threshold 0.1 on the holder span, fired once
 * - cached-image catch: img.complete && naturalWidth > 0 counts as loaded
 * - zoom-out starts only when BOTH in viewport AND loaded
 * - double rAF so the browser paints scale(1.2) before transitioning
 * - after 1300ms the lux classes are removed (phase=settled) so component
 *   hover transforms take over cleanly
 */
(function () {
  'use strict';

  var SETTLE_MS = 1300;

  function init(img) {
    if (img.dataset.luxInit) return;
    img.dataset.luxInit = '1';

    var holder = img.closest('[data-lux-holder]') || img;
    var visible = false;
    var loaded = img.complete && img.naturalWidth > 0;
    var started = false;

    function maybeStart() {
      if (!visible || !loaded || started) return;
      started = true;
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () {
          img.classList.add('lux-loaded');
          setTimeout(function () {
            img.classList.remove('lux-img', 'lux-loaded');
          }, SETTLE_MS);
        });
      });
    }

    var observer = new IntersectionObserver(
      function (entries) {
        if (entries[0].isIntersecting) {
          visible = true;
          observer.disconnect();
          maybeStart();
        }
      },
      { threshold: 0.1 }
    );
    observer.observe(holder);

    img.addEventListener('load', function () {
      loaded = true;
      maybeStart();
    });
  }

  function initAll(root) {
    (root || document).querySelectorAll('img.lux-img').forEach(init);
  }

  initAll(document);

  // Theme Editor / Section Rendering API re-renders
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });

  window.Dylys = window.Dylys || {};
  window.Dylys.initLuxImages = initAll;
})();
